import { render, staticRenderFns } from "./set-accounts.vue?vue&type=template&id=4a7a6f19&scoped=true&"
import script from "./set-accounts.vue?vue&type=script&lang=js&"
export * from "./set-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a6f19",
  null
  
)

export default component.exports